// extracted by mini-css-extract-plugin
module.exports = {"root":"_2Koli","bg":"_11ECO","ctr":"tIr4e","top":"ocfeZ","bot":"_2DxwI"};